import React, { FC, useEffect, useState } from "react";
import {
  createInstance,
  OptimizelyProvider,
  setLogger,
} from "@optimizely/react-sdk";
import Cookies from "js-cookie";

interface VolvatOptimizelyProviderProps {
  sdkKey?: string;
  children?: JSX.Element;
}

export const VolvatOptimizelyProvider: FC<VolvatOptimizelyProviderProps> = ({
  sdkKey,
  children,
}) => {
  const [windowRendered, setWindowRendered] = useState(false);
  useEffect(() => {
    setWindowRendered(true);
  }, []);

  setLogger(null);

  if (!windowRendered) {
    return null;
  }

  const optimizelyClient = createInstance({
    sdkKey: sdkKey ?? "",
  });

  return (
    <OptimizelyProvider
      optimizely={optimizelyClient}
      timeout={500}
      user={{ id: Cookies.get("EPiServer_CMS_AnonymousId") ?? null }}
    >
      {children}
    </OptimizelyProvider>
  );
};
